import { useTheme } from "@emotion/react";
import type { FC } from "react";
import { MdOutlineEdit } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";

import { CustomerDoc } from "@megaron/docs-contracts";

type Props = {
  reporterName: string;
  reporterEmail: string;
  emailMatchedCustomer?: CustomerDoc;
};

export const SupportTicketManualReporterCard: FC<Props> = ({
  reporterName,
  reporterEmail,
  emailMatchedCustomer,
}) => {
  const theme = useTheme();
  const trimmedName = reporterName.trim();
  const trimmedEmail = reporterEmail.trim();
  const displayName = trimmedName || (trimmedEmail ? trimmedEmail.split("@")[0] : "—");

  return (
    <div
      css={{
        borderRadius: theme.smallBorderRadius,
        background: theme.colors.primaryLight,
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        border: `2px solid ${theme.colors.primary}`,
      }}
    >
      <div
        css={{
          color: theme.colors.primary,
          background: "white",
          padding: "0.5rem 0.875rem",
          alignSelf: "stretch",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: `1px solid ${theme.colors.border}`,
        }}
      >
        <MdOutlineEdit size={18} />
      </div>
      <div
        css={{
          minWidth: 0,
          padding: "0.5rem 0.75rem",
          display: "flex",
          flex: "1 0 0",
          flexDirection: "column",
          gap: "0.25rem",
        }}
      >
        <div css={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.5rem" }}>
          <div css={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
            <span css={{ fontSize: "0.75rem", fontWeight: 600, color: theme.colors.primary }}>
              Zgłaszający · wpis ręczny
            </span>
            <span css={{ fontSize: "0.875rem", fontWeight: 700, color: theme.colors.primary }}>{displayName}</span>
          </div>
          {trimmedEmail ? (
            <span
              css={{
                fontSize: "0.75rem",
                color: theme.colors.primary,
                flexShrink: 0,
                textAlign: "right",
              }}
            >
              {trimmedEmail}
            </span>
          ) : null}
        </div>
        {emailMatchedCustomer ? (
          <span css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>
            W CRM znaleziono klienta o tym e-mailu:{" "}
            <Link
              to={`/crm/customers/id/${emailMatchedCustomer.uuid}`}
              css={{ color: theme.colors.primary, fontWeight: 600 }}
            >
              {emailMatchedCustomer.name}
            </Link>
          </span>
        ) : null}
      </div>
    </div>
  );
};
